enum SignatureConfirmation {
  ADULT = 'ADULT',
  CARRIER_CONFIRMATION = 'CARRIER_CONFIRMATION',
  CERTIFIED = 'CERTIFIED',
  INDIRECT = 'INDIRECT',
  STANDARD = 'STANDARD',
}

export default SignatureConfirmation;
